<template>
  <!-- Module -->
  <div class="module" :class="loading ? 'module--loading' : ''">
    <div class="module__media bg-dark-pink"></div>
    <div class="module__header">
      <h2>Search by programme name or keyword</h2>
    </div>
    <div class="module__main">
      <!-- Search Form -->
      <!-- Search Input -->
      <fieldset>
        <cludo-vue-input class="form-control form-control--search" placeholder="Search...">
          <span class="sr-only">Search</span>
          <i class="icon-search" aria-hidden="true"></i>
        </cludo-vue-input>
      </fieldset>

      <!-- Collapse Toggle -->
      <button type="button" class="button button--small button--block button--toggle toggle toggle--m"
        aria-expanded="false" aria-controls="search-filters" data-toggle="true">
        Filter courses
        <span v-if="isFiltering" class="badge bg-white">{{
          filtersCount
          }}</span>
      </button>

      <!-- Collapse -->
      <div id="search-filters" class="collapse collapse--tablet-expanded">
        <div class="collapse__content">
          <!-- Search Checkboxes Filter: Study type -->
          <cludo-vue-check-boxes :options="[
            {
              label: 'Taught',
              name: 'taught',
              field: 'StudyType',
              value: 'Taught',
            },
            {
              label: 'Research',
              name: 'research',
              field: 'StudyType',
              value: 'Research',
            },
          ]">
            <div class="filter-heading">
              <legend>Study type</legend>
            </div>
          </cludo-vue-check-boxes>

          <!-- Search Checkboxes Filter: Mode of study  -->
          <cludo-vue-check-boxes :options="[
            {
              label: 'Full-time study',
              name: 'full-time',
              field: 'StudyModes',
              value:
                'Full-time, Full-time&#44; Part-time'
            },
            {
              label: 'Part-time study',
              name: 'part-time',
              field: 'StudyModes',
              value:
                'Part-time, Full-time&#44; Part-time'
            },
          ]">
            <div class="filter-heading">
              <legend>Mode of study </legend>
            </div>
          </cludo-vue-check-boxes>

          <!-- Search Checkboxes Filter: Delivery method -->
          <cludo-vue-check-boxes :options="[
            {
              label: 'On campus',
              name: 'on-campus',
              field: 'StudyDeliveryMethod',
              value:
                'on-campus, on-campus & online-learning, on-campus & online-with-on-campus-learning, on-campus & distance-learning',
            },
            {
              label: 'Online',
              name: 'online-learning',
              field: 'StudyDeliveryMethod',
              value:
                'online-learning,on-campus & online-learning,online-learning & online-with-on-campus-learning,online-learning & distance-learning',
            },
            {
              label: 'Online with on campus elements',
              name: 'online-with-on-campus-learning',
              field: 'StudyDeliveryMethod',
              value:
                'online-with-on-campus-learning,on-campus & online-with-on-campus-learning,online-learning & online-with-on-campus-learning,online-with-on-campus-learning & distance-learning',
            },
            {
              label: 'Distance learning',
              name: 'distance-learning',
              field: 'StudyDeliveryMethod',
              value:
                'distance-learning,on-campus & distance-learning,online-learning & distance-learning,online-with-on-campus-learning & distance-learning',
            },
          ]">
            <div class="filter-heading">
              <legend>Delivery method</legend>
            </div>
          </cludo-vue-check-boxes>

          <!-- Search Checkboxes Filter: Subject -->
          <cludo-vue-check-boxes :options="subjectOptions">
            <div class="filter-heading">
              <legend>Subject</legend>
            </div>
          </cludo-vue-check-boxes>

          <!-- Search Checkboxes Filter: Faculty -->
          <cludo-vue-check-boxes :options="[
            {
              label: 'Arts, Law and Social Sciences',
              name: 'arts law and social sciences',
              field: 'Faculty',
              value: 'Arts Law and Social Sciences',
            },
            {
              label: 'Health and Life Sciences',
              name: 'health and life sciences',
              field: 'Faculty',
              value: 'Health and Life Sciences',
            },
            {
              label: 'Science and Engineering',
              name: 'science and engineering',
              field: 'Faculty',
              value: 'Science and Engineering',
            },
          ]">
            <div class="filter-heading">
              <legend>Faculty</legend>
            </div>
          </cludo-vue-check-boxes>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// see https://app.asana.com/1/9135350440099/project/1207999102732962/task/1216458107561653?focus=true for changes to the below
const subjectData = [
  {
    label: 'Dentistry',
    name: 'dentistry',
    field: 'Schools',
    value: 'Bristol Dental School',
  },
  {
    label: 'Medicine',
    name: 'medicine',
    field: 'Schools',
    value: 'Bristol Medical School',
  },
  {
    label: 'Veterinary Science',
    name: 'veterinary science',
    field: 'Schools',
    value: 'Bristol Veterinary School',
  },
  {
    label: 'Innovation and Entrepreneurship',
    name: 'innovation and entrepreneurship',
    field: 'Schools',
    value: 'Centre for Innovation and Entrepreneurship',
  },
  {
    label: 'Policy Studies',
    name: 'policy studies',
    field: 'Schools',
    value: 'School for Policy Studies',
  },
  // {
  //   label: 'Anatomy',
  //   name: 'anatomy',
  //   field: 'Schools',
  //   value: 'School of Anatomy',
  // },
  {
    label: 'Arts',
    name: 'arts',
    field: 'Schools',
    value: 'School of Arts',
  },
  // {
  //   label: 'Biochemistry',
  //   name: 'biochemistry',
  //   field: 'Schools',
  //   value: 'School of Biochemistry',
  // },
  {
    label: 'Biological Sciences',
    name: 'biological sciences',
    field: 'Schools',
    value: 'School of Biological Sciences',
  },
  // {
  //   label: 'Cellular and Molecular Medicine',
  //   name: 'cellular and molecular medicine',
  //   field: 'Schools',
  //   value: 'School of Cellular and Molecular Medicine',
  // },
  {
    label: 'Chemistry',
    name: 'chemistry',
    field: 'Schools',
    value: 'School of Chemistry',
  },
  {
    label: 'Civil, Aerospace and Design Engineering',
    name: 'civil, aerospace and design engineering',
    field: 'Schools',
    value: 'School of Civil&#44; Aerospace and Design Engineering',
  },
  {
    label: 'Computer Science',
    name: 'computer science',
    field: 'Schools',
    value: 'School of Computer Science',
  },
  {
    label: 'Earth Sciences',
    name: 'earth sciences',
    field: 'Schools',
    value: 'School of Earth Sciences',
  },
  {
    label: 'Economics',
    name: 'economics',
    field: 'Schools',
    value: 'School of Economics',
  },
  {
    label: 'Education',
    name: 'education',
    field: 'Schools',
    value: 'School of Education',
  },
  {
    label: 'Electrical, Electronic and Mechanical Engineering',
    name: 'electrical, electronic and mechanical engineerings',
    field: 'Schools',
    value: 'School of Electrical&#44; Electronic and Mechanical Engineering',
  },
  {
    label: 'Engineering Mathematics and Technology',
    name: 'engineering mathematics and technology',
    field: 'Schools',
    value: 'School of Engineering Mathematics and Technology',
  },
  {
    label: 'Geographical Sciences',
    name: 'geographical sciences',
    field: 'Schools',
    value: 'School of Geographical Sciences',
  },
  {
    label: 'Humanities',
    name: 'humanities',
    field: 'Schools',
    value: 'School of Humanities',
  },
  {
    label: 'Mathematics',
    name: 'mathematics',
    field: 'Schools',
    value: 'School of Mathematics',
  },
  {
    label: 'Modern Languages',
    name: 'modern languages',
    field: 'Schools',
    value: 'School of Modern Languages',
  },
  {
    label: 'Physics',
    name: 'physics',
    field: 'Schools',
    value: 'School of Physics',
  },
  // {
  //   label: 'Physiology, Pharmacology and Neuroscience',
  //   name: 'physiology, pharmacology and neuroscience',
  //   field: 'Schools',
  //   value: 'School of Physiology&#44; Pharmacology and Neuroscience',
  // },
  // {
  //   label: 'Psychological Science',
  //   name: 'Psychological Science',
  //   field: 'Schools',
  //   value: 'School of Psychological Science',
  // },
  {
    label: 'Sociology, Politics and International Studies',
    name: 'Sociology, Politics and International Studies',
    field: 'Schools',
    value: 'School of Sociology&#44; Politics and International Studies',
  },
  {
    label: 'Health Professions Education',
    name: 'health professions education',
    field: 'Schools',
    value: 'Teaching and Learning for Health Professionals',
  },
  {
    label: 'Business',
    name: 'business',
    field: 'Schools',
    value: 'University of Bristol Business School',
  },
  {
    label: 'Law',
    name: 'law',
    field: 'Schools',
    value: 'University of Bristol Law School',
  },
  {
    label: 'Anatomy',
    name: 'anatomy',
    field: 'Schools',
    value: 'Bristol Anatomy Centre',
  },
  {
    label: 'Psychology and Neuroscience',
    name: 'psychology and neuroscience',
    field: 'Schools',
    value: 'School of Psychology and Neuroscience',
  },
  {
    label: 'Biochemistry and Biomedical Sciences',
    name: 'biochemistry and biomedical sciences',
    field: 'Schools',
    value: 'School of Biochemistry and Biomedical Sciences',
  },
]
export default {
  props: {
    filterParamaters: {
      type: Object,
      default: () => { },
    },
    isFiltering: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filtersCount() {
      const searchFilterCount =
        this.filterParamaters?.searchFilter?.length ?? 0;
      const sortFilterCount = this.filterParamaters?.sortFilter?.length ?? 0;
      const rangeFilterCount =
        Object.keys(this.filterParamaters?.rangeFilter)?.length ?? 0;
      const checkboxFilterCount =
        this.filterParamaters?.checkboxFilter.filter(
          (el) => el.checked === true
        ).length ?? 0;
      const count =
        searchFilterCount +
        sortFilterCount +
        rangeFilterCount +
        checkboxFilterCount;
      return count;
    },
    subjectOptions() {
      return subjectData.sort((a, b) => {
        return a.label.localeCompare(b.label);
      })
    },
  },
};
</script>

<style lang="scss">
.module {
  &__main {
    fieldset {
      padding: 0;
      border: none;
      width: 100%;
    }

    .form-control--input {

      input,
      label {
        cursor: pointer;
      }
    }
  }
}
</style>
